import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/form/baseInputs/Button';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { FIRST_DEATH_CLIENT_ID_SEARCH_PARAM } from '@/modules/estateTaxScenarios/EstateTaxScenarios.constants';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';
import { diagnostics } from '@/utils/diagnostics';

export function ManagePortabilityButton() {
  const navigate = useNavigate();
  const canEdit = useCanEditHouseholdData();

  const { householdId, primaryClients } = useHouseholdDetailsContext();

  const primaryClientId = primaryClients?.[0]?.id;

  const handleClick = useCallback(() => {
    if (!householdId) {
      diagnostics.error(
        'householdId is missing from manage portability button'
      );
      return;
    }

    if (!primaryClientId) {
      diagnostics.error(
        'primaryClientId is missing from manage portability button'
      );
      return;
    }

    navigate(
      getCompletePathFromRouteKey(
        ROUTE_KEYS.HOUSEHOLD_DETAILS_GIFTING_ESTATE_TAX_CALCULATION_TROWSER,
        { householdId },
        {
          [FIRST_DEATH_CLIENT_ID_SEARCH_PARAM]: primaryClientId,
        }
      )
    );
  }, [householdId, navigate, primaryClientId]);

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={handleClick}
      disabled={!householdId || !primaryClientId}
    >
      {canEdit ? 'Manage' : 'View'} portability & DSUE
    </Button>
  );
}
